import React from 'react'

const CollapseSession = props => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8.00016 1.33325C4.32683 1.33325 1.3335 4.32659 1.3335 7.99992C1.3335 11.6733 4.32683 14.6666 8.00016 14.6666C11.6735 14.6666 14.6668 11.6733 14.6668 7.99992C14.6668 4.32659 11.6735 1.33325 8.00016 1.33325ZM10.6135 8.49992H5.28016C5.00683 8.49992 4.78016 8.27325 4.78016 7.99992C4.78016 7.72659 5.00683 7.49992 5.28016 7.49992H10.6135C10.8868 7.49992 11.1135 7.72659 11.1135 7.99992C11.1135 8.27325 10.8935 8.49992 10.6135 8.49992Z'
      fill='#B64FCD'
    />
  </svg>
)

export default CollapseSession
